<template>
  <div class="notificationList">
    <notificationList></notificationList>
  </div>
</template>

<script>
import notificationList from './notificationList.vue'

export default {
  components: {
    notificationList
  }
}
</script>
<style scoped>
.notificationList {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/notification/notification.vue